module.exports = __webpack_public_path__ + "static/media/9DESA30.06d223d5.jpg";